import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _pt from "prop-types";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useRef, useState } from 'react';
import FocusLock from 'react-focus-lock';
import classNames from 'classnames';
import { Heading } from '@lmig/lmds-react-typography';
import { Button } from '@lmig/lmds-react-button';
import { IconButton, IconClose } from '@lmig/lmds-react-icons';
import "./modal.css";
var instance = 0;
export var Modal = function Modal(_ref) {
  var _classNames;

  var id = _ref.id,
      title = _ref.title,
      _ref$mandatory = _ref.mandatory,
      mandatory = _ref$mandatory === void 0 ? false : _ref$mandatory,
      ctaArray = _ref.ctaArray,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$mobileTakeover = _ref.mobileTakeover,
      mobileTakeover = _ref$mobileTakeover === void 0 ? false : _ref$mobileTakeover,
      _ref$modalStyle = _ref.modalStyle,
      modalStyle = _ref$modalStyle === void 0 ? 'standard' : _ref$modalStyle,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      closeFunc = _ref.closeFunc,
      className = _ref.className,
      _ref$closeButtonProps = _ref.closeButtonProps,
      closeButtonProps = _ref$closeButtonProps === void 0 ? {} : _ref$closeButtonProps,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["id", "title", "mandatory", "ctaArray", "size", "mobileTakeover", "modalStyle", "isOpen", "closeFunc", "className", "closeButtonProps", "children"]);

  var focusRef = useRef(null);
  var modalRef = useRef(null);

  var _useState = useState(function () {
    instance++;
    return id || "lm-Modal-".concat(instance);
  }),
      _useState2 = _slicedToArray(_useState, 1),
      uniqueId = _useState2[0];

  useEffect(function () {
    if (document) {
      if (isOpen) {
        document.body.classList.add('lm-Modal--freezeScroll');
      } else {
        document.body.classList.remove('lm-Modal--freezeScroll');
      }
    }

    return function cleanup() {
      if (document) {
        document.body.classList.remove('lm-Modal--freezeScroll');
      }
    };
  }); // Focus managment

  useEffect(function () {
    if (isOpen) {
      focusRef.current = document.activeElement;

      if (modalRef.current) {
        modalRef.current.focus();
      }
    }

    return function () {
      if (focusRef.current) {
        focusRef.current.focus();
        focusRef.current = null;
      }
    };
  }, [isOpen, uniqueId]);

  var handleBackgroundKeyDown = function handleBackgroundKeyDown(event) {
    if (event.target.classList.contains('lm-Modal-bg') || event.keyCode === 27 || event.key === 'Escape' || event.key === 'Esc') {
      if (closeFunc) {
        closeFunc();
      }
    }
  };

  var handleCloseButton = function handleCloseButton(event) {
    var onClick = closeButtonProps.onClick;

    if (onClick) {
      onClick(event);
    }

    if (closeFunc) {
      closeFunc(event);
    }
  };

  var renderCloseButton = function renderCloseButton() {
    var _closeButtonProps$id = closeButtonProps.id,
        closeId = _closeButtonProps$id === void 0 ? "close-".concat(uniqueId) : _closeButtonProps$id,
        closeClassName = closeButtonProps.className,
        restCloseButtonProps = _objectWithoutProperties(closeButtonProps, ["id", "className"]);

    return /*#__PURE__*/React.createElement(IconButton, _extends({}, restCloseButtonProps, {
      id: closeId,
      className: classNames('lm-ButtonClose', closeClassName),
      onClick: handleCloseButton
    }), /*#__PURE__*/React.createElement(IconClose, {
      size: "16"
    }));
  };

  return /*#__PURE__*/React.createElement(FocusLock, {
    noFocusGuards: true
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: classNames((_classNames = {
      'lm-Modal': true,
      'lm-Modal--mobileTakeover': mobileTakeover
    }, _defineProperty(_classNames, "lm-Modal--".concat(size), size), _defineProperty(_classNames, "lm-Modal--".concat(modalStyle), modalStyle), _defineProperty(_classNames, 'is-open', isOpen), _classNames), className),
    id: uniqueId,
    role: "dialog",
    "aria-hidden": !isOpen,
    "aria-labelledby": "lm-Modal-title",
    tabIndex: -1,
    onKeyDown: !mandatory ? handleBackgroundKeyDown : undefined,
    ref: modalRef
  }, otherProps), /*#__PURE__*/React.createElement("section", {
    className: "lm-Modal-wrapper",
    role: "dialog",
    "aria-labelledby": "lm-Modal-title"
  }, !mandatory ? renderCloseButton() : null, title ? /*#__PURE__*/React.createElement("header", {
    className: "lm-Modal-header"
  }, /*#__PURE__*/React.createElement("h1", {
    id: "lm-Modal-title",
    className: "lm-Modal-title"
  }, /*#__PURE__*/React.createElement(Heading, {
    type: "h3",
    tag: "span"
  }, title))) : null, children ? /*#__PURE__*/React.createElement("div", {
    className: "lm-Modal-body"
  }, children) : null, ctaArray ? /*#__PURE__*/React.createElement("footer", {
    className: "lm-Modal-footer"
  }, ctaArray.map(function (cta, index) {
    var label = cta.label,
        buttonProps = _objectWithoutProperties(cta, ["label"]);

    var key = "cta-".concat(index);
    return /*#__PURE__*/React.createElement(Button, _extends({
      key: key
    }, buttonProps), label);
  })) : null), /*#__PURE__*/React.createElement("div", {
    className: "lm-Modal-bg",
    onClick: !mandatory ? closeFunc : undefined,
    role: "none"
  })));
};
Modal.propTypes = {
  /** Adds an optional ID for the modal window, generates derivative IDs for any included buttons. */
  id: _pt.string,

  /** Add custom classes to this element. */
  className: _pt.string,

  /** Generates a semantically correct H1 in the style of Heading Level 3. */
  title: _pt.node,

  /**
     * Removes the close button and disables dismissal via background click: don't forget to include a CTA!
     * @default false
     */
  mandatory: _pt.bool,

  /** Pass your CTA buttons as an array of objects with two required props: label and onClick, additional Button props can be passed if desired. */
  ctaArray: _pt.array,

  /**
     * Use 'takeover' if a takeover-style modal is desired at all breakpoints.
     * @default 'medium'
     */
  size: _pt.oneOf(['small', 'medium', 'large', 'takeover']),

  /**
     * At the mobile breakpoint, a non-takeover size will display as a takeover.
     * @default false
     */
  mobileTakeover: _pt.bool,

  /**
     * Adds color themes to the modal.
     * @default 'standard'
     */
  modalStyle: _pt.oneOf(['standard', 'error']),

  /**
     * Controls the state of the modal.
     * @default false
     */
  isOpen: _pt.bool,

  /** Pass a function to control the open/closed state of the modal. */
  closeFunc: _pt.func,

  /** Modal contents go here. */
  children: _pt.node
};